import useMaldivesOnePointPromoAvailability from 'components/MaldivesDirect/OnePointPromo/useMaldivesOnePointPromoAvailability'
import { MALDIVES_CHARTER_ROUTE } from 'api/lib/flightDealMap'
import { useRewardSeatsEnabled } from 'hooks/Flights/useRewardSeatsEnabled'
import MaldivesCharterBuyPointsBanner from './MaldivesCharterBuyPointsBanner'
import MaldivesCharterOnePointCalendarBanner from './MaldivesCharterOnePointCalendarBanner'

interface Props {
  flush?: boolean
  rooms: Array<App.Occupants>
  duration: number
  charterBundleRoute?: App.CharterBundleRoute
}

function MaldivesCharterCalendarBanner({ flush = false, rooms, duration, charterBundleRoute }: Props) {
  const isPromoAvailable = useMaldivesOnePointPromoAvailability({
    rooms,
    duration,
    disabled: charterBundleRoute !== MALDIVES_CHARTER_ROUTE,
  })
  const isRewardSeatsEnabled = useRewardSeatsEnabled()

  if (isPromoAvailable) {
    return <MaldivesCharterOnePointCalendarBanner flush={flush} />
  }

  if (isRewardSeatsEnabled) {
    return <MaldivesCharterBuyPointsBanner flush={flush} />
  }

  return null
}

export default MaldivesCharterCalendarBanner
